<template>
<div v-if="c_data">
    <div v-if="show_info">
        <RowComponent
            label="condizioni ambientali"
            :value="`stabilità termica locale (°C/h): `+ c_data.local_stability"
        >
        </RowComponent>
        <RowComponent
            label="descrizione locale installazione"
            :value="c_data.room_description"
        >
        </RowComponent>
    </div>
    <BasicCard v-else :title="'Condizioni ambientali'">
        <v-form v-model="valid.object">
            <div class="d-flex flex-column ma-2">
                <v-text-field dense outlined
                    label="stabilità termica locale (°C/h)*"
                    v-model="c_data.local_stability"
                    :rules="[rules.mandatory]"
                    suffix="°C/h"
                ></v-text-field>
                <v-textarea dense outlined
                    class="ml-2"
                    label="Descrizione locale installazione"
                    v-model="c_data.room_description"
                    textarea
                ></v-textarea>
            </div>
        </v-form>
    </BasicCard>
</div>
</template>
<script>
import BasicCard from '../../../components/utils/Basic_card'
import RowComponent from '../../../components/utils/RowComponent'

import {CustomDataMixin} from "../../../utils/CustomDataMixin.js"
import {getModel} from '../../../utils/model'
// import _ from 'lodash'

export default {
    mixins: [CustomDataMixin],
    components: {BasicCard, RowComponent},
    data() {
        return {
            valid: {
                object: false,
                metro: false
            }
        }
    },
    mounted() {
        let model = null
        model = getModel('LatCustomData')
        if (model) {
            this.c_data = model(this.o_data)
        } else {
            this.c_data = _.cloneDeep(this.o_data)
        }
    }
}
</script>